import React from 'react';
import { Link, Navigate, useParams } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import PageHeader from '../innovher/PageHeader';
import SEO from '../SEO';
import { architecturePages } from '../../data/architecturePages';
import { STOCK } from '../../lib/images';

export default function ArchitecturePage() {
  const { slug } = useParams();
  const page = architecturePages.find((p) => p.slug === slug);
  if (!page) return <Navigate to="/" replace />;

  const image = STOCK[slug] || STOCK.innovventures;

  return (
    <>
      <SEO title={page.seoTitle || page.name} description={page.seoDescription || page.summary} />
      <PageHeader
        eyebrow={page.category || 'Capability'}
        title={page.name === 'InnovVentures' ? 'Venture Studio' : page.name}
        subtitle={page.headline || page.summary}
        image={image}
      />
      <section className="bg-[#08080a] text-white py-16 border-t border-white/10">
        <div className="max-w-3xl mx-auto px-6 lg:px-8 space-y-8">
          {(page.intro || [page.summary]).map((para) => (
            <p key={para.slice(0, 24)} className="text-white/70 text-lg leading-relaxed">
              {para}
            </p>
          ))}

          {page.blocks?.map((block, i) => (
            <div key={block.title || i} className="border border-white/10 rounded-2xl p-6 bg-white/[0.02]">
              {block.title && <h2 className="text-xl font-semibold mb-4">{block.title}</h2>}
              {block.body && <p className="text-white/60 leading-relaxed">{block.body}</p>}
              {Array.isArray(block.items) && (
                <ul className="space-y-4">
                  {block.items.map((item) =>
                    typeof item === 'string' ? (
                      <li key={item} className="text-white/70 text-sm">• {item}</li>
                    ) : (
                      <li key={item.title}>
                        <div className="font-medium text-white">{item.title}</div>
                        <p className="text-sm text-white/55 mt-1">{item.text}</p>
                      </li>
                    )
                  )}
                </ul>
              )}
            </div>
          ))}

          {page.cta?.external ? (
            <a
              href={page.cta.to}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-[#ff8ec5] font-medium hover:text-white"
            >
              {page.cta.label} <ArrowUpRight className="w-4 h-4" />
            </a>
          ) : (
            <Link
              to={page.cta?.to || '/contact'}
              className="inline-flex items-center gap-2 text-[#ff8ec5] font-medium hover:text-white"
            >
              {page.cta?.label || 'Contact Us'} <ArrowUpRight className="w-4 h-4" />
            </Link>
          )}
        </div>
      </section>
    </>
  );
}
